import { mobileThreshold } from './mobileThreshold';

const isMobile = () =>
  process.browser && window.matchMedia(`(max-width: ${mobileThreshold - 1}px)`).matches;

export const matchMedia = {
  isMobile,
};
